var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('parallax',{staticClass:"section page-header header-filter",style:(_vm.headerStyle)}),_c('div',{staticClass:"main"},[_c('ProfileComp')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }